import { Component, OnInit, effect, ChangeDetectorRef } from '@angular/core';
import { User } from './user.model';
import { AddUserComponent } from './add-user/add-user.component';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/../core/services/popup/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { registrationInfo } from '../../types/registrationInfo';
import { AdministrationService } from '../administration/administration.service';
import { Router } from '@angular/router';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SubscriptionService } from '../subscriptions/subscriptions.service';
import { registrationListInfo } from '../../types/registrationListInfo';
import { gigyaInfo } from '../../types/gigyaInfo';
import { LoginService } from '../login/login.service';
import jwt_decode from 'jwt-decode';
import { JwtService } from '../../shared/services/jwt/jwt.service';
import { ConfirmationPopupComponent } from '../../shared/components/confirmation-popup/confirmation-popup.component';
import { MAT_MENU_DEFAULT_OPTIONS } from '@angular/material/menu';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.sass',
  standalone: false,
  providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: { overlayPanelClass: 'dsr-menu-density-minus-4-overlay' }
    }
  ]
})

export class AdministrationComponent implements OnInit {
  editingRowIndex: number | null = null;
  editingUserClone: User | null = null;
  addForm: FormGroup;
  rows: FormArray;
  regForm: FormGroup;
  regRows: FormArray;
  existingData: any[] = [];
  orgAdminInfo: any;
  userCount = 0;
  disableDelete = false;
  successPop = false;
  regFailPop = false;
  selectedRowsList: registrationInfo[] = [];
  failurePop = false;
  failureMsg = '';
  emailArray: any[] = [];
  regFailureList: any;
  deleteList: any[] = [];
  editList: any[] = [];
  selectedDeleteRowList: gigyaInfo[] = [];
  deleteResponseList: gigyaInfo[] = [];
  gigyaUid: any;
  orgAdminLoading = false;
  ndUsers = 0;
  asmdorUsers = 0;
  ndAccessLimit: number;
  asmdorAccessLimit: number;
  isDesc = true;
  column = '';
  showOrgUsers = true;
  showAccessUsers = false;
  isStatusInactive = false;
  selectedVariant = 'USER';
  todayDate = '';
  updateUser = {
    mailId: '',
    ndAccess: false,
    asmdorAccess: false,
    rateLimit: 0,
    coAdmin: false
  };
  variantList = [
    { code: 'USER', label: 'USER_MANAGEMENT' }, { code: 'ACCESS', label: 'ACCESS_MANAGEMENT' }
  ];
  globalRateLimit = 0;
  userDisplayedColumns: string[] = ['firstName', 'lastName', 'userMail', 'status', 'actions'];

  get accessDisplayedColumns(): string[] {
    const columns = ['firstName', 'lastName', 'userMail', 'ndAccess'];
    if(this.orgAdminInfo?.accountId === 4 || this.orgAdminInfo?.accountId === 6) {
      columns.push('asmdorAccess');
    }
    if(this.orgAdminInfo?.accountId === 6) {
      columns.push('coAdmin');
    }
    columns.push('rateLimit', 'usage', 'actions');
    return columns;
  }

  userRegistrationCount: number;

  constructor(private popupService: PopupService, private fb: FormBuilder, public router: Router,
              private orgAdminService: AdministrationService, private jwtService: JwtService,
              private subscriptionService: SubscriptionService, private loginService: LoginService,
              private translate: TranslateService, private registrationList: registrationListInfo,
              private cdr: ChangeDetectorRef) {
    effect(() => {
      this.orgAdminInfo = this.loginService.gigyaResponse;
      if(this.orgAdminInfo) {
        this.userRegistrationCount = this.orgAdminInfo.accessIdentifier === 'ORGADMIN' ? this.orgAdminInfo.userCounts + 20 : 30;
        this.getAdminVinRateDetails();
        this.getSubscriptions();
        // to add rows of the form same as registration dto
        if((this.orgAdminInfo.accountId === 1 || this.orgAdminInfo.accountId === 3) && this.orgAdminInfo.accessIdentifier === 'INDADMIN') {
          this.addForm = this.fb.group({
            items: [{
              accountId: this.orgAdminInfo.accountId,
              firstName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]),
              lastName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]),
              userMail: new FormControl('', [Validators.required, Validators.email]),
              password: "Xxxxxxa5o",
              companyName: this.orgAdminInfo.companyName,
              state: this.orgAdminInfo.city,
              postalCode: this.orgAdminInfo.postalCode,
              address: this.orgAdminInfo.address,
              countryId: this.orgAdminInfo.countryId,
              countryName: "xxxxxx",
              diallingCode: this.orgAdminInfo.diallingCode,
              mobileNumber: this.orgAdminInfo.mobileNumber,
              vatCode: "",
              accessIdentifier: "INDADMIN",
              solidoNumber: this.orgAdminInfo.solidoNo,
              languageCode: this.orgAdminInfo.languageCode,
              status: "Registered",
              editale: false,
              select: new FormControl(false),
              ndAccess: new FormControl(true, Validators.required),
              asmdorAccess: new FormControl(true, Validators.required),
              rateLimit: this.orgAdminInfo.rateLimit,
              globalRateLimit: this.orgAdminInfo.globalRateLimit,
              usage: this.orgAdminInfo.usage,
              coAdmin: new FormControl(false)
            }]
          });
          this.ndAccessLimit = 10;
          this.asmdorAccessLimit = 10;
        } else if (this.orgAdminInfo.accessIdentifier === "ORGADMIN") {
          this.addForm = this.fb.group({
            items: [{
              accountId: this.orgAdminInfo.accountId,
              firstName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]),
              lastName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]),
              userMail: new FormControl('', [Validators.required, Validators.email]),
              password: "Xxxxxxa5o",
              companyName: this.orgAdminInfo.companyName,
              state: this.orgAdminInfo.city,
              postalCode: this.orgAdminInfo.postalCode,
              address: this.orgAdminInfo.address,
              countryId: this.orgAdminInfo.countryId,
              countryName: "xxxxxx",
              diallingCode: this.orgAdminInfo.diallingCode,
              mobileNumber: this.orgAdminInfo.mobileNumber,
              vatCode: "",
              accessIdentifier: "ORGADMIN",
              solidoNumber: this.orgAdminInfo.solidoNo,
              languageCode: this.orgAdminInfo.languageCode,
              status: "Registered",
              editale: false,
              select: new FormControl(false),
              ndAccess: new FormControl(true, Validators.required),
              asmdorAccess: new FormControl(true, Validators.required),
              rateLimit: this.orgAdminInfo.rateLimit,
              globalRateLimit: this.orgAdminInfo.globalRateLimit,
              usage: this.orgAdminInfo.usage,
              coAdmin: new FormControl(false)
            }]
          });
          this.ndAccessLimit = this.userRegistrationCount;
          this.asmdorAccessLimit = this.userRegistrationCount;
        } else if (this.orgAdminInfo.accessIdentifier === "ORGUSER" && this.orgAdminInfo.accountId === 6 && this.orgAdminInfo.coAdmin === true) {
          this.addForm = this.fb.group({
            items: [{
              accountId: this.orgAdminInfo.accountId,
              firstName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]),
              lastName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]),
              userMail: new FormControl('', [Validators.required, Validators.email]),
              password: "Xxxxxxa5o",
              companyName: this.orgAdminInfo.companyName,
              state: this.orgAdminInfo.city,
              postalCode: this.orgAdminInfo.postalCode,
              address: this.orgAdminInfo.address,
              countryId: this.orgAdminInfo.countryId,
              countryName: "xxxxxx",
              diallingCode: this.orgAdminInfo.diallingCode,
              mobileNumber: this.orgAdminInfo.mobileNumber,
              vatCode: "",
              accessIdentifier: "ORGUSER",
              solidoNumber: this.orgAdminInfo.solidoNo,
              languageCode: this.orgAdminInfo.languageCode,
              status: "Registered",
              editale: false,
              select: new FormControl(false),
              ndAccess: new FormControl(true, Validators.required),
              asmdorAccess: new FormControl(true, Validators.required),
              rateLimit: this.orgAdminInfo.rateLimit,
              globalRateLimit: this.orgAdminInfo.globalRateLimit,
              usage: this.orgAdminInfo.usage,
              coAdmin: new FormControl(false)
            }]
          });
          this.ndAccessLimit = this.userRegistrationCount;
          this.asmdorAccessLimit = this.userRegistrationCount;
        }
        this.rows = this.fb.array([]);
        this.addForm.addControl('rows', this.rows);
        this.globalRateLimit = this.orgAdminInfo.globalRateLimit;
        this.getExistingUsers(this.orgAdminInfo.solidoNo);
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.getTodayDate();
  }

  deleteUser(userToDelete: User) {
    let dialogRef = this.popupService.openDialog(ConfirmationPopupComponent, {
      data: {
        message: this.translate.instant('ORGADMIN_DELETE_USER_CONFIM'),
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if(confirmed) {
        this.existingData = this.existingData.filter(
          (user) => user.id !== userToDelete.id,
        );
      }
    });
  }

  startEditingRow(index: number, row: any, email: any): void {
    // Discard uncommitted changes on a previously edited row before editing a new one
    if(this.editingRowIndex !== null && this.editingRowIndex !== index) {
      this.refreshRows();
    }
    this.editingRowIndex = index;
    this.editingUserClone = { ...this.existingData[index] };
    this.editRow(row, email, index);
  }

  cancelEditingRow(): void {
    this.editingRowIndex = null;
    this.editingUserClone = null;
    this.refreshRows();
  }

  private refreshRows(): void {
    this.showAccessUsers = false;
    this.rows = this.fb.array([]);
    this.existingData.forEach((data: any) => {
      this.rows.push(this.existingValue(data));
    });
    this.addForm.setControl('rows', this.rows);
    this.calculateUsersCount();
    this.disableControls();
    this.showAccessUsers = true;
  }

  confirmEditingRow(row: any): void {
    if(this.editingRowIndex && this.editingUserClone) {
      this.existingData[this.editingRowIndex] = this.editingUserClone;
      this.editingRowIndex = null;
      this.editingUserClone = null;
    }
    this.editUser(row);
    this.disableControls();
  }

  sort(array: any, property: any) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = property;
    const direction = this.isDesc ? 1 : -1;
    // using spread operator to achieve 2 way binding for array
    array = [
      ...array.sort(function (a: any, b: any) {
        if(a[property] < b[property]) {
          return -1 * direction;
        } else if(a[property] > b[property]) {
          return 1 * direction;
        } else {
          return 0;
        }
      }),
    ];
    return array;
  }

  onRemoveRow(rowIndex: number) {
    this.rows.removeAt(rowIndex);
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  createItemFormGroup(addUser: any): FormGroup {
    // to create a form array same as registration dto that has the same values as parent
    if((this.orgAdminInfo.accountId === 1 || this.orgAdminInfo.accountId === 3) &&
      this.orgAdminInfo.accessIdentifier === 'INDADMIN') {
      return this.fb.group({
        accountId: this.orgAdminInfo.accountId,
        firstName: addUser.firstName,
        lastName: addUser.lastName,
        userMail: addUser.email,
        password: 'Xxxxxxa5o',
        companyName: this.orgAdminInfo.companyName,
        state: this.orgAdminInfo.city,
        postalCode: this.orgAdminInfo.postalCode,
        address: this.orgAdminInfo.address,
        countryId: this.orgAdminInfo.countryId,
        countryName: 'xxxxxx',
        diallingCode: this.orgAdminInfo.diallingCode,
        mobileNumber: this.orgAdminInfo.mobileNumber,
        vatCode: this.orgAdminInfo.vatNumber,
        accessIdentifier: 'INDUSER',
        solidoNumber: this.orgAdminInfo.solidoNo,
        parentId: this.orgAdminInfo.userId,
        languageCode: this.orgAdminInfo.languageCode,
        status: 'Pending',
        editable: false,
        select: new FormControl(false),
        ndAccess: new FormControl(false),
        asmdorAccess: new FormControl(false),
        rateLimit: new FormControl(
          { value: 30, disabled: true },
          Validators.required,
        ),
        globalRateLimit: 0,
        usage: 0,
        coAdmin: new FormControl(false)
      });
    } else {
      return this.fb.group({
        accountId: this.orgAdminInfo.accountId,
        firstName: addUser.firstName,
        lastName: addUser.lastName,
        userMail: addUser.email,
        password: 'Xxxxxxa5o',
        companyName: this.orgAdminInfo.companyName,
        state: this.orgAdminInfo.city,
        postalCode: this.orgAdminInfo.postalCode,
        address: this.orgAdminInfo.address,
        countryId: this.orgAdminInfo.countryId,
        countryName: 'xxxxxx',
        diallingCode: this.orgAdminInfo.diallingCode,
        mobileNumber: this.orgAdminInfo.mobileNumber,
        vatCode: this.orgAdminInfo.vatNumber,
        accessIdentifier: 'ORGUSER',
        solidoNumber: this.orgAdminInfo.solidoNo,
        parentId: this.orgAdminInfo.userId,
        languageCode: this.orgAdminInfo.languageCode,
        status: 'Pending',
        editable: false,
        select: new FormControl(false),
        ndAccess: new FormControl(false),
        asmdorAccess: new FormControl(false),
        rateLimit: new FormControl(
          { value: 30, disabled: true },
          Validators.required,
        ),
        globalRateLimit: 0,
        usage: 0,
        coAdmin: new FormControl(false)
      });
    }
  }

  existingValue(item: any): FormGroup {
    return this.fb.group({
      firstName: item.firstName,
      lastName: item.lastName,
      userMail: item.userMail,
      status: 'Registered',
      accessIdentifier: item.accessIdentifier,
      select: false,
      editable: false,
      ndAccess: item.ndAccess,
      asmdorAccess: item.asmdorAccess,
      userId: item.userId,
      gigyaUid: item.gigyaUid,
      rateLimit: item.rateLimit,
      globalRateLimit: item.globalRateLimit,
      usage: item.usage,
      coAdmin: item.coAdmin
    });
  }

  getExistingUsers(solidoNumber: string) {
    this.orgAdminLoading = true;
    let userInfo = { solidoNumber: solidoNumber };
    let userData: string = this.jwtService.encode(userInfo, 'secret');
    this.orgAdminService.getExistingUsers(userData).subscribe((response: any) => {
      this.orgAdminLoading = false;
      let encryptData = response;
      let orgUsersData: any = jwt_decode(encryptData);
      this.existingData = [];
      // A co-admin (ORGUSER) is also returned in the org users list; the logged-in user is already added as the first row
      const loggedInMail = (this.orgAdminInfo?.userMail || '').toLowerCase();
      this.syncLoggedInUser(orgUsersData.orgUsers.responseDtos, loggedInMail);
      this.existingData = this.sort(orgUsersData.orgUsers.responseDtos.filter((user: any) =>
          !user.disabled && (user.userMail || '').toLowerCase() !== loggedInMail),
        'userMail',
      );
      this.existingData.unshift(this.orgAdminInfo);
      // Keep the ORGADMIN record first (stable sort preserves the order of the remaining users)
      this.existingData.sort((a: any, b: any) =>
        Number(b.accessIdentifier === 'ORGADMIN') - Number(a.accessIdentifier === 'ORGADMIN'));
      this.clearFormArray(this.rows);
      this.existingData.forEach((data: any) => {
        this.rows.push(this.existingValue(data));
      });
      this.calculateUsersCount();
      this.cdr.detectChanges();
    },
      (err: any) => {
        this.orgAdminLoading = false;
      },
    );
  }

  // the session copy of the logged-in user is stale when another admin changed their access (e.g. from the org admin app)
  private syncLoggedInUser(serverUsers: any[], loggedInMail: string): void {
    const fresh = serverUsers?.find((user: any) => (user.userMail || '').toLowerCase() === loggedInMail);
    if(!fresh || !this.orgAdminInfo) {
      return;
    }
    const keys = ['ndAccess', 'asmdorAccess', 'rateLimit', 'coAdmin', 'usage'];
    const changed = keys.filter((key) => fresh[key] !== undefined && fresh[key] !== this.orgAdminInfo[key]);
    if(changed.length) {
      changed.forEach((key) => (this.orgAdminInfo[key] = fresh[key]));
      this.loginService.setGigyaResponse(this.orgAdminInfo);
    }
  }

  getTodayDate() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    let hr = today.getHours();
    let min = today.getMinutes();
    let sec = today.getSeconds();

    let date, month, hour, minutes, seconds;

    if(dd < 10) {
      date = '0' + dd;
    } else {
      date = dd;
    }
    if(mm < 10) {
      month = '0' + mm;
    } else {
      month = mm;
    }
    if(hr < 10) {
      hour = '0' + hr;
    } else {
      hour = hr;
    }
    if(min < 10) {
      minutes = '0' + min;
    } else {
      minutes = min;
    }
    if(sec < 10) {
      seconds = '0' + sec;
    } else {
      seconds = sec;
    }
    this.todayDate =
      yyyy +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hour +
      ':' +
      minutes +
      ':' +
      seconds;
  }

  getSubscriptions() {
    this.orgAdminLoading = true;
    let request: any = { userMail: this.orgAdminInfo.userMail, type: 'DO' };
    let userRequest: string = this.jwtService.encode(request, 'secret');
    this.subscriptionService.getSubscriptionDetails(userRequest).subscribe(
      (response: any) => {
        this.orgAdminLoading = false;
        let encryptData = response;
        let subData: any = jwt_decode(encryptData);
        if(subData.userSubscriptionDetails.subscriptionsListDto.length !== 0) {
          subData.userSubscriptionDetails.subscriptionsListDto.forEach(
            (element: any) => {
              if(
                element.expired === false &&
                (element.offerStatus == 0 || element.offerStatus == 1)
              ) {
                this.isStatusInactive = false;
              }
            },
          );
        } else {
          this.isStatusInactive = true;
        }
      },
      (error: any) => {
        this.orgAdminLoading = false;
      },
    );
  }

  calculateUsersCount() {
    this.ndUsers = 0;
    this.asmdorUsers = 0;
    let items: any = [];
    (<FormArray>this.addForm.get('rows'))?.controls.forEach((item: any) => {
      items.push(item);
      if(item.getRawValue().ndAccess) {
        this.ndUsers++;
      }
      if(item.getRawValue().asmdorAccess) {
        this.asmdorUsers++;
      }
    });
    this.userCount = items.length;
    this.disableControls();
    this.cdr.detectChanges();
  }

  disableControls() {
    (<FormArray>this.addForm.get('rows'))?.controls.forEach((item: any) => {
      item.get('ndAccess')?.disable();
      item.get('asmdorAccess')?.disable();
      item.get('coAdmin')?.disable();
    });
    this.cdr.detectChanges();
  }

  editRow(row: any, email: any, index: any) {
    (<FormArray>this.addForm.get('rows'))?.controls.forEach((item: any) => {
      if(item.value.userMail == email && (item.value.accessIdentifier == 'ORGUSER' || item.value.accessIdentifier == 'INDUSER')) {
        item.get('editable')?.setValue(true);
        item.get('ndAccess')?.enable();
        item.get('asmdorAccess')?.enable();
        item.get('rateLimit')?.enable();
        // co-admin access is never editable from the edit action
        item.get('coAdmin')?.disable();
      }
    });
  }

  userDelete(mail: string, status: string) {
    if(status === 'Registered') {
      let dialogRef = this.popupService.openDialog(ConfirmationPopupComponent, {
        data: {
          message: this.translate.instant('ORGADMIN_DELETE_USER_CONFIM'),
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if(confirmed) {
          mail = mail.toLowerCase();
          this.deleteList.push(mail);
          this.deleteOrgUser();
        } else {
          return;
        }
      });
    } else {
      this.popupService.openDialog(MessagePopupComponent, {
        data: { message: this.translate.instant('NOT_REG_USER_MSG') },
      });
    }
  }

  editUser(row: any) {
    this.editList = [];
    this.editList.push(row);

    const currentUserMail = this.editList[0].controls.userMail.value;
    const newNdAccess = this.editList[0].controls.ndAccess.value;
    const newAsmdorAccess = this.editList[0].controls.asmdorAccess.value;

    // Find the original user's access settings before the edit
    const originalUser = this.existingData.find(
      (user) => user.userMail === currentUserMail,
    );

    // co-admin access can't be changed here, always keep the stored value
    const newCoAdminAccess = !!originalUser?.coAdmin;

    this.updateUser.mailId = currentUserMail;
    this.updateUser.ndAccess = newNdAccess;
    this.updateUser.asmdorAccess = newAsmdorAccess;
    this.updateUser.coAdmin = newCoAdminAccess;
    this.updateUser.rateLimit = Number(this.editList[0].controls.rateLimit.value);

    // Calculate what the counts WOULD be after this edit
    let ndCount = this.ndUsers;
    let asmdorCount = this.asmdorUsers;

    // Remove original user's contribution to the count
    if(originalUser) {
      if(originalUser.ndAccess) ndCount--;
      if(originalUser.asmdorAccess) asmdorCount--;
    }

    // Add new user's contribution to the count
    if(newNdAccess) ndCount++;
    if(newAsmdorAccess) asmdorCount++;

    // Check if EITHER access type EXCEEDS the limit
    if(ndCount > this.ndAccessLimit || asmdorCount > this.asmdorAccessLimit) {
      if(originalUser) {
        this.editList[0].get('ndAccess')?.setValue(!!originalUser.ndAccess, {
          emitEvent: false,
        });
        this.editList[0].get('asmdorAccess')?.setValue(
          !!originalUser.asmdorAccess,
          { emitEvent: false },
        );
      }
      this.popupService.openDialog(MessagePopupComponent, {
        data: {
          message: `You have reached the maximum limit for Access preferences for your Account!`,
        },
      });
      this.disableControls();
    } else {
      this.submitForm();
    }
  }

  submitForm() {
    this.orgAdminLoading = true;
    this.orgAdminService.updateSubscriptionStatus(this.updateUser).subscribe((response: any) => {
        this.orgAdminLoading = false;
        if(!response.error) {
          this.editingRowIndex = null;
          this.editingUserClone = null;
          // the logged-in user's own row is built from the session data, so keep it in sync too
          if((this.orgAdminInfo?.userMail || '').toLowerCase() === (this.updateUser.mailId || '').toLowerCase()) {
            Object.assign(this.orgAdminInfo, {
              ndAccess: this.updateUser.ndAccess,
              asmdorAccess: this.updateUser.asmdorAccess,
              rateLimit: this.updateUser.rateLimit,
              coAdmin: this.updateUser.coAdmin,
            });
            // persist the change, otherwise the session signal/storage (read by other components and on reload) stays stale
            this.loginService.setGigyaResponse(this.orgAdminInfo);
          }
          this.popupService.openDialog(MessagePopupComponent, {
            data: {
              message: 'Access preferences saved successfully for the User!',
            },
          });
          // reload from the server so every row (e.g. co-admin flag reset on siblings) reflects the saved state
          this.getExistingUsers(this.orgAdminInfo.solidoNo);
        }
      },
      (error: any) => {
        this.orgAdminLoading = false;
        this.popupService.openDialog(MessagePopupComponent, {
          data: {
            message: 'Error occured in saving Access preferences for the User!',
          },
        });
      },
    );
  }

  selectActivateUser(mail: string, status: string) {
    if(status === 'Registered') {
      let dialogRef = this.popupService.openDialog(ConfirmationPopupComponent, {
        data: {
          message: this.translate.instant('ORGADMIN_ACTIVATE_USER_CONFIM'),
        },
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if(confirmed) {
          let getGigyaUID = this.existingData.filter((item) => {
            if(item.userMail === mail.toLowerCase()) {
              return item.gigyaUid;
            }
          });
          this.gigyaUid = getGigyaUID[0].gigyaUid;
          this.activateUser(mail);
        }
      });
    } else {
      this.popupService.openDialog(MessagePopupComponent, {
        data: { message: this.translate.instant('NOT_REG_USER_MSG') },
      });
    }
  }

  addNewUser() {
    let dialogRef = this.popupService.openDialog(AddUserComponent);
    dialogRef.afterClosed().subscribe((addUser: any) => {
      if(addUser) {
        this.onAddRow(addUser);
      }
    });
  }

  onAddRow(addUser: any) {
    this.deleteList = [];
    this.regRows = this.rows;
    this.regForm = this.addForm;
    this.regRows.push(this.createItemFormGroup(addUser));
    let mail = addUser.email.toLowerCase();
    this.emailArray.push(mail);
    this.registerOrgUser();
  }

  registerOrgUser() {
    let array = this.emailArray;
    // to maintain the object same as registration DTO
    this.selectedRowsList = this.regForm.get('rows')?.value.filter((item: any) => {
        if(array.indexOf(item.userMail.toLowerCase()) > -1 && item.status === 'Pending') {
          delete item.status;
          delete item.select;
          delete item.userId;
          delete item.globalRateLimit;
          delete item.usage;
          delete item.editable;
          item.userMail = item.userMail.toLowerCase();
          item.rateLimit = 30;
          return true;
        }
        return false;
      });
    if(this.selectedRowsList.length !== 0) {
      this.orgAdminLoading = true;
      this.registrationList.registrationsListDto = this.selectedRowsList;
      this.showOrgUsers = false;
      let regData: string = this.jwtService.encode(this.registrationList, 'secret');
      this.orgAdminService.registerSecondaryUser(regData).subscribe((response: any) => {
          this.orgAdminLoading = false;
          this.displayRegFails(response.responseListDto);
          if(this.regFailureList) {
            this.popupService.openDialog(MessagePopupComponent, {
              data: { message: this.regFailureList },
            });
            this.emailArray = [];
            setTimeout(() => {
              this.getExistingUsers(this.orgAdminInfo.solidoNo);
            }, 500);
            this.showOrgUsers = true;
            this.regFailureList = '';
          } else {
            this.popupService.openDialog(MessagePopupComponent, {
              data: {
                message: this.translate.instant(
                  'ORGADMIN_USER_REGISTER_SUCCESS',
                ),
              },
            });
            this.emailArray = [];
            setTimeout(() => {
              this.getExistingUsers(this.orgAdminInfo.solidoNo);
            }, 500);
            this.showOrgUsers = true;
          }
        },
        (err: any) => {
          this.orgAdminLoading = false;
          this.popupService.openDialog(MessagePopupComponent, {
            data: {
              message: this.translate.instant(
                'ORGADMIN_REGISTER_FAILED_SYSTEM',
              ),
            },
          });
          this.emailArray = [];
          setTimeout(() => {
            this.getExistingUsers(this.orgAdminInfo.solidoNo);
          }, 500);
          this.showOrgUsers = true;
        },
      );
    }
  }

  deleteOrgUser() {
    let deleteArray = this.deleteList;
    // to maintain the object same as response DTO
    let rows = this.addForm.get('rows')?.value;
    this.selectedDeleteRowList = this.addForm.get('rows')?.value.filter((item: any) => {
        if(deleteArray.indexOf(item.userMail.toLowerCase()) > -1 && item.status === 'Registered') {
          delete item.status;
          delete item.select;
          delete item.ndAccess;
          delete item.asmdorAccess;
          delete item.coAdmin;
          delete item.editable;
          item.userMail = item.userMail.toLowerCase();
          item.error = false;
          item.errorCode = null;
          item.errorMessage = null;
          item.regToken = null;
          item.accNumber = null;
          item.accountId = null;
          item.firstName = null;
          item.lastName = null;
          item.hasLoggedIn = null;
          item.address = null;
          item.companyName = null;
          item.mobileNumber = null;
          item.postalCode = null;
          item.city = null;
          item.countryId = null;
          item.subscribeStatus = null;
          item.solidoNo = null;
          item.accessIdentifier = null;
          item.languageCode = null;
          delete item.lastName;
          delete item.firstName;
          delete item.userMail;
          return true;
        }
        return false;
      });
    if(this.selectedDeleteRowList.length !== 0) {
      this.orgAdminLoading = true;
      let deleteUser: any = { responseDto: [] };
      deleteUser.responseDto = this.selectedDeleteRowList;
      let delUsersData: string = this.jwtService.encode(deleteUser, 'secret');
      this.orgAdminService.deleteExistingUsers(delUsersData).subscribe((response: any) => {
          if(response[0].error === false) {
            this.orgAdminLoading = false;
            this.deleteResponseList = response;
            this.deleteList = [];
            this.addForm.addControl('rows', rows);
            this.popupService.openDialog(MessagePopupComponent, {
              data: {
                message: this.translate.instant('ORGADMIN_USER_DELETE_SUCCESS'),
              },
            });
            this.getExistingUsers(this.orgAdminInfo.solidoNo);
          } else {
            this.orgAdminLoading = false;
            this.deleteResponseList = response;
            this.deleteList = [];
            this.addForm.addControl('rows', rows);
            this.popupService.openDialog(MessagePopupComponent, {
              data: {
                message: this.translate.instant('ORGADMIN_USER_DELETE_FAILURE'),
              },
            });
            this.getExistingUsers(this.orgAdminInfo.solidoNo);
          }
        },
        (error: any) => {
          this.orgAdminLoading = false;
          this.popupService.openDialog(MessagePopupComponent, {
            data: {
              message: this.translate.instant('ORGADMIN_DELETE_FAILED_SYSTEM'),
            },
          });
          this.deleteList = [];
          this.getExistingUsers(this.orgAdminInfo.solidoNo);
        },
      );
    }
  }

  displayRegFails(responseList: any[]) {
    responseList.forEach((response: any) => {
      if(response.error && response.errorMessage) {
        this.regFailureList = this.translate.instant(
          'ORGADMIN_EXISTING_EMAIL_ERROR',
        );
      }
    });
  }

  closeFailPop() {
    this.failurePop = false;
    this.regFailPop = false;
    this.failureMsg = '';
    this.router.navigateByUrl('orgAdmin');
  }

  closeRegFailPop() {
    this.regFailPop = false;
    this.regFailureList = [];
    this.clearFormArray(this.rows);
    this.getExistingUsers(this.orgAdminInfo.solidoNo);
    this.disableDelete = false;
  }

  getAdminVinRateDetails() {
    let userMailId = { userMail: '' };
    userMailId.userMail = this.orgAdminInfo.userMail;
    this.orgAdminService.getVinRateLimit(userMailId).subscribe((response: any) => {
      this.orgAdminInfo.globalRateLimit = response.globalRateLimit;
    });
    this.orgAdminService.getUsageRate(userMailId).subscribe((response: any) => {
      this.orgAdminInfo.usage = response.usage;
    });
  }

  closeSuccessPop() {
    this.getAdminVinRateDetails();
    this.successPop = false;
    this.clearFormArray(this.rows);
    this.disableDelete = false;
    this.getExistingUsers(this.orgAdminInfo.solidoNo);
  }

  getControls() {
    // return a new array reference so mat-table's dataSource binding detects changes
    // pushed into the FormArray in place (e.g. after async user data loads)
    return (<FormArray>this.addForm?.get('rows'))?.controls?.slice() ?? [];
  }

  forgotPassword(email: string, status: string) {
    this.orgAdminLoading = true;
    if(status === 'Registered') {
      let dialogRef = this.popupService.openDialog(ConfirmationPopupComponent, {
        data: {
          message: this.translate.instant('ORGADMIN_FORGOT_PASSWORD_CONFIM'),
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if(confirmed) {
          let userInfo = { gigya_loginId: email };
          let userData: string = this.jwtService.encode(userInfo, 'secret');
          this.loginService.passwordReset(userData).subscribe((response: any) => {
              this.orgAdminLoading = false;
              if(!response.error) {
                this.popupService.openDialog(MessagePopupComponent, {
                  data: {
                    message: `${this.translate.instant('MSG_PASSWORD_RESET_USER')} ${email}`,
                  },
                });
              } else {
                this.popupService.openDialog(MessagePopupComponent, {
                  data: { message: response.errorMessage },
                });
              }
            },
            (error: any) => {
              this.orgAdminLoading = false;
              this.popupService.openDialog(MessagePopupComponent, {
                data: { message: this.translate.instant('GIGYA_500000') },
              });
            },
          );
        }
        this.orgAdminLoading = false;
      });
    } else {
      this.popupService.openDialog(MessagePopupComponent, {
        data: { message: this.translate.instant('NOT_REG_USER_MSG') },
      });
      this.orgAdminLoading = false;
    }
  }

  activateUser(mail: string) {
    this.orgAdminLoading = true;
    let userInfo = { gigya_uid: this.gigyaUid };
    let userData: string = this.jwtService.encode(userInfo, 'secret');
    this.loginService.activateUser(userData).subscribe(
      (response: any) => {
        this.orgAdminLoading = false;
        if(!response.error) {
          this.popupService.openDialog(MessagePopupComponent, {
            data: {
              message: `${this.translate.instant('MSG_ACTIVATION_LINK_USER')} ${mail}`,
            },
          });
          this.gigyaUid = '';
        } else {
          this.popupService.openDialog(MessagePopupComponent, {
            data: { message: this.translate.instant('MSG_TRY_LATER') },
          });
          this.gigyaUid = '';
        }
      },
      (error: any) => {
        this.orgAdminLoading = false;
        this.popupService.openDialog(MessagePopupComponent, {
          data: { message: this.translate.instant('MSG_TRY_LATER') },
        });
        this.gigyaUid = '';
      },
    );
  }

  changeSelectedVariant(event: any) {
    this.selectedVariant = event.value;
    if(this.selectedVariant === 'USER') {
      this.showOrgUsers = true;
      this.showAccessUsers = false;
    } else {
      this.showOrgUsers = false;
      this.showAccessUsers = true;
    }
  }

  sendRegisteredOk(user: any): void {
    this.popupService.openDialog(MessagePopupComponent, {
      data: {
        message: `The activation link has been sent to ${user.userMail || user.email}`,
      },
    });
  }

  onDeleteUser(user: any): void {
    this.deleteUser(user);
  }
}
